@if (dataFooter$ | async; as dataFooter) {
  @defer (on idle; on timer(5s)) {
    <footer [style.background-color]="style().backgroundColor | color" [style.color]="style().textColor | color">
      <div class="row container">
        <div class="col-lg-6 col-xs-12">
          <a [routerLink]="dataFooter.logoUrl?.[0]?.url || routeToHomepage">
            @if (breakpoints() === "mobile") {
              <img
                [height]="22"
                [style.filter]="style().textColor === 'BLACK' ? 'brightness(0)' : 'brightness(0) invert(1)'"
                [width]="96"
                alt="logo Perene"
                class="logo"
                ngSrc="/assets/images/logo.svg" />
            } @else {
              <img
                [height]="44"
                [style.filter]="style().textColor === 'BLACK' ? 'brightness(0)' : 'brightness(0) invert(1)'"
                [width]="192"
                alt="logo Perene"
                class="logo"
                ngSrc="/assets/images/logo.svg" />
            }
          </a>
        </div>
        <div class="col-lg-6 col-xs-12 row">
          @for (
            links of [dataFooter.links.primary, dataFooter.links.secondary];
            track links;
            let first = $first;
            let last = $last
          ) {
            <ul [class.col-lg-3]="last" [class.col-lg-8]="first" [class.col-lg-offset-1]="last" class="list col-xs-12">
              @for (link of links; track link) {
                <li [class.list-item-first]="first" class="list-item">
                  @if (link.url && link.label) {
                    <a
                      [class.link--uppercase]="first"
                      [routerLink]="link.url"
                      [style.color]="style().textColor | color"
                      class="link"
                      dynamicUrl>
                      {{ link.label }}
                    </a>
                  }
                </li>
                @if (link.hasSeparator) {
                  <hr [style.background-color]="style().textColor | color" />
                }
              }
              @if (first) {
                <li class="is-mobile">
                  <hr [style.background-color]="style().textColor | color" />
                </li>
              }
              @if (dataFooter.socialNetworks && last) {
                <li class="list-item-socials">
                  <app-social-networks [items]="dataFooter.socialNetworks" [style]="socialNetworksStyle()" />
                </li>
              }
            </ul>
          }
        </div>
      </div>
    </footer>
  }
}
